import React from 'react';
// import Swiper core and required components
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';

// install Swiper components
SwiperCore.use([Navigation, Pagination, A11y]);

const MySwiper = (data) => {
  
  return (
    <div className="swiper-shape">
      {data.swiperdata && 
        data.swiperdata.length !== 0
      ?
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          loop={true}
          //onSwiper={(swiper) => setTimeout(() => swiper.slideNext(10),1000)}
          //onSlideChange={(swiper) => console.log(swiper.realIndex)}
        >
          {data.swiperdata.map(function(img){
            return (
              img.image && (
                <SwiperSlide key={img.image._id} style={{
                  backgroundImage: `url(${img.image._url})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center center',
                  backgroundSize: 'cover'
                }}>
                  <img src={img.image._url} alt={img.image.name} />
                </SwiperSlide>
              )
            )
          })}
        </Swiper>
      :
        ''
      }
    </div>
  );
};

export default MySwiper;